
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Cabserviceinsolapur() {



const cardData = {
  keyword: 'Corporate Cab Services in Solapur MIDC',
  heading: 'eTravo: Efficient Corporate Cab Services in Solapur MIDC',
  headingDescription: `eTravo delivers reliable and well-structured corporate cab services in Solapur MIDC, tailored for the growing transportation needs of industrial and commercial enterprises. From daily employee commutes to executive transfers and client pickups, we provide flexible and safe travel solutions that ensure punctuality and comfort. Our fleet consists of GPS-enabled, air-conditioned vehicles driven by trained chauffeurs, and our booking systems are designed for maximum convenience. With cost-effective monthly rental plans and on-demand cab availability, eTravo simplifies business travel across the Solapur industrial zone. We are committed to helping companies enhance efficiency through dependable mobility solutions.`,

  top: 'Major Industrial Zones and Business Hubs in Solapur MIDC Covered by eTravo',
  topPlaces: [
    {
      title: 'Solapur MIDC Industrial Area',
      description: `The central industrial estate in Solapur housing textile, manufacturing, and processing units. eTravo offers scheduled employee pickup and drop services tailored to shift patterns and operational needs.`
    },
    {
      title: 'Solapur Textile Hub',
      description: `A key commercial region with numerous textile mills and suppliers. Our corporate cabs support daily workforce travel and executive logistics throughout the day.`
    },
    {
      title: 'Solapur Railway Station',
      description: `An important rail hub for business travel. eTravo facilitates seamless transfers between the station and office campuses, improving client and employee connectivity.`
    },
    {
      title: 'Solapur Airport',
      description: `We provide executive cab services for airport pickups and drop-offs, ideal for business travelers requiring punctual and comfortable transport options.`
    },
    {
      title: 'Local Business Parks & Warehousing Units',
      description: `Our cab services cover daily logistics and transportation support for warehouses and logistics companies in and around Solapur MIDC.`
    }
  ],

  services: [
    {
      name: 'Solapur MIDC Corporate Cab Rentals',
      description: `Customizable rental solutions for companies in Solapur MIDC, offering daily, weekly, and monthly cab packages that accommodate varying travel needs efficiently.`
    },
    {
      name: 'Employee Transport Cab Solapur MIDC',
      description: `Safe and punctual daily transport for employees using GPS-monitored, air-conditioned cabs. Routes and timings are customized to match shift operations and business hours.`
    },
    {
      name: 'Business Cab Services Solapur MIDC',
      description: `On-demand cab services for business meetings, vendor visits, and inter-office travel. We ensure availability, reliability, and professionalism in every trip.`
    },
    {
      name: 'Corporate Staff Cabs Solapur MIDC',
      description: `Optimized cab routing for large employee groups, helping companies streamline commuting while maintaining productivity and reducing absenteeism.`
    },
    {
      name: 'Reliable Corporate Cab Service Solapur MIDC',
      description: `We emphasize punctuality, clean vehicles, and well-trained drivers, making us a trusted choice for multiple corporate clients in Solapur MIDC.`
    },
    {
      name: 'AC Corporate Cabs Solapur MIDC',
      description: `Our fleet features fully air-conditioned cabs, regularly serviced for hygiene and comfort, suitable for both daily commuting and VIP travel.`
    },
    {
      name: 'Staff Pickup and Drop Cab Solapur MIDC',
      description: `Our transport service runs round-the-clock, accommodating all work shifts and ensuring safe, timely travel for factory and office employees.`
    },
    {
      name: 'Affordable Business Cab Rentals Solapur MIDC',
      description: `Cost-effective rental plans with transparent billing and scalable options, suitable for startups, SMEs, and large corporations alike.`
    },
    {
      name: 'Executive Cab Services Solapur MIDC',
      description: `High-end transport services for senior executives and visiting dignitaries. Luxury vehicles with trained chauffeurs ensure a premium experience.`
    },
    {
      name: 'Monthly Corporate Cab Rentals Solapur MIDC',
      description: `Fixed-route, monthly rental solutions designed for corporate employee mobility, complete with GPS tracking and performance reporting.`
    },
    {
      name: 'Industrial Area Employee Transport Solapur MIDC',
      description: `Full-service employee transport system covering all industrial zones, with a focus on group travel, safety, and shift alignment.`
    },
    {
      name: 'Corporate Client Cabs Solapur MIDC',
      description: `Specialized cabs for client meetings, office visits, and business events that require professional service and dependable time management.`
    },
    {
      name: 'Business Meeting Cabs Solapur MIDC',
      description: `Fast-response business cab bookings for unscheduled meetings or last-minute travel needs within Solapur MIDC and surrounding areas.`
    },
    {
      name: 'Solapur Industrial Area Cab Hire',
      description: `Reliable cab hire services covering factory clusters, warehouses, and corporate campuses, supporting efficient mobility for all types of staff.`
    },
    {
      name: 'Corporate Shuttle Cabs Solapur MIDC',
      description: `Efficient group transportation for employees during peak hours, meetings, and training sessions. Ideal for organizations looking for shuttle-based commuting models.`
    }
  ],

  tableData: [
    ['Solapur MIDC Corporate Cab Rentals', 'Employee Transport Cab Solapur MIDC'],
    ['Business Cab Services Solapur MIDC', 'Corporate Staff Cabs Solapur MIDC'],
    ['Reliable Corporate Cab Service Solapur MIDC', 'AC Corporate Cabs Solapur MIDC'],
    ['Staff Pickup and Drop Cab Solapur MIDC', 'Affordable Business Cab Rentals Solapur MIDC'],
    ['Executive Cab Services Solapur MIDC', 'Monthly Corporate Cab Rentals Solapur MIDC'],
    ['Industrial Area Employee Transport Solapur MIDC', 'Corporate Client Cabs Solapur MIDC'],
    ['Business Meeting Cabs Solapur MIDC', 'Solapur Industrial Area Cab Hire'],
    ['Corporate Shuttle Cabs Solapur MIDC', '']
  ],


"whychoose": [
  {
    "WhyChooseheading": "Dependable Corporate Cab Services for Solapur MIDC",
    "WhyChoosedescription": "eTravo specializes in providing reliable and efficient cab services tailored for businesses in Solapur MIDC, a key industrial area with a variety of manufacturing and textile companies. Our services ensure smooth daily commutes for employees, helping reduce delays and improving overall operational productivity. We design customized transportation plans that cater to the specific shift timings and routes relevant to Solapur MIDC’s industrial landscape."
  },
  {
    "WhyChooseheading": "Diverse Fleet to Meet Varied Business Requirements",
    "WhyChoosedescription": "Our fleet includes comfortable sedans, spacious SUVs, and multi-utility vehicles to suit different corporate travel needs — from daily employee transportation to client meetings and inter-office travel. Every vehicle is regularly maintained and equipped with safety and comfort features to provide a hassle-free ride."
  },
  {
    "WhyChooseheading": "Experienced Drivers with In-depth Local Knowledge",
    "WhyChoosedescription": "Our professional drivers are well-acquainted with Solapur MIDC routes, traffic conditions, and alternative paths, ensuring timely and safe transportation. They are also trained in corporate etiquette and customer service, providing a courteous and secure experience for all passengers."
  },
  {
    "WhyChooseheading": "Flexible Booking Options to Accommodate Shifts",
    "WhyChoosedescription": "We offer flexible ride scheduling, including fixed-shift services, rotating schedules, and on-demand bookings. This helps businesses effectively manage transportation requirements, regardless of workforce size or shift complexities."
  },
  {
    "WhyChooseheading": "Real-Time Tracking for Enhanced Safety and Transparency",
    "WhyChoosedescription": "Our cabs are equipped with GPS tracking systems, allowing corporate clients to monitor employee rides live. This feature improves security, provides real-time updates, and helps ensure accountability for all trips."
  },
  {
    "WhyChooseheading": "Clear and Detailed Billing for Easy Expense Management",
    "WhyChoosedescription": "We provide transparent, GST-compliant invoices with comprehensive trip details and fare breakdowns, simplifying the process of expense tracking and reimbursement for corporate finance teams."
  },
  {
    "WhyChooseheading": "Stringent Safety and Hygiene Practices",
    "WhyChoosedescription": "In compliance with health and safety standards, our vehicles are sanitized regularly and our drivers adhere to strict hygiene protocols, ensuring a safe travel environment for your employees."
  },
  {
    "WhyChooseheading": "Dedicated Account Managers for Seamless Support",
    "WhyChoosedescription": "Each corporate client benefits from a dedicated account manager who handles booking coordination, addresses concerns promptly, and customizes transportation solutions to align with company-specific requirements."
  }
]
}

const faqData = [
  [
    {
      question: "Which areas around Solapur MIDC do you serve?",
      answer: "We serve Solapur MIDC and the surrounding industrial and commercial zones to ensure smooth transportation for corporate clients."
    },
    {
      question: "Can we schedule regular rides for our employees?",
      answer: "Yes, we provide options for recurring rides tailored to your shift schedules and workforce needs."
    },
    {
      question: "Do you offer monthly billing services?",
      answer: "Certainly. We provide monthly billing with detailed invoices and trip summaries to assist your accounting processes."
    },
    {
      question: "Are your drivers trained in corporate etiquette and safety protocols?",
      answer: "Yes, our drivers undergo thorough training to maintain professionalism, safety, and customer satisfaction."
    },
    {
      question: "How do you ensure passenger safety during rides?",
      answer: "We utilize GPS tracking, maintain vehicles regularly, and enforce strict hygiene and safety measures throughout each trip."
    },
    {
      question: "Is there a dedicated support team for corporate clients?",
      answer: "Yes, a dedicated account manager is assigned to each client to provide personalized support and quick resolution of any issues."
    }
  ]
];

const testimonialsData = [
  {
    name: "Mr. Prakash Deshmukh",
    designation: "Operations Manager, Solapur Textile Ltd.",
    rating: [1, 1, 1, 1, 1],
    text: "“eTravo’s cab service has enhanced our employee commute efficiency with punctual and professional drivers.”"
  },
  {
    name: "Ms. Sneha Patil",
    designation: "HR Executive, Solapur Engineering Works",
    rating: [1, 1, 1, 1, 1],
    text: "“The flexible scheduling and excellent customer support from eTravo have made managing our corporate transportation seamless.”"
  }
];






























    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service in Solapur MIDC",
  "image": "https://www.etravo.in/images/keyword/cab-service-solapur-midc.jpg",
  "description": "Reliable corporate cab service in Solapur MIDC offering employee transport, business travel, industrial area cabs, and affordable AC corporate rentals with professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "4300"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1699",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/cab-service-solapur-midc"
  }
};








    return (
        <div>

<Helmet>
  <title>Cab Service in Solapur MIDC | Corporate & Industrial Cabs | eTravo</title>
  <meta 
    name="description" 
    content="Book reliable corporate cab service in Solapur MIDC for staff commute, business meetings, and industrial transport. Affordable AC corporate cabs available at eTravo." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/76.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Cabserviceinsolapur;